import { queryOptions } from '@tanstack/react-query';
import { apiClient } from '@/api/axios';
import { API } from '@/api/endpoints';
import { STALE_TIME } from '@/api/staleTimes';
import { userTypeListSchema, type UserType } from '../types/userType.types';

export const userTypeQueryKeys = {
  all: () => ['user-types'] as const,
  list: () => [...userTypeQueryKeys.all(), 'list'] as const,
};

export const userTypesQueryOptions = () =>
  queryOptions({
    queryKey: userTypeQueryKeys.list(),
    queryFn: async (): Promise<UserType[]> => {
      const res = await apiClient.get(API.settings.userTypes);
      return userTypeListSchema.parse(res.data);
    },
    staleTime: STALE_TIME,
  });
